import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import HotelAssociations from './hotel-associations/hotel-associations';
import template from './hotel-center-assignment-template.pug';
import HotelGroups from './hotel-groups/hotel-groups';
import HotelGroupsUINext from './hotel-groups/hotel-groups-uinext';
import CustomFilterView from './assignment-utils/custom-filter-view';
import EditControl from './assignment-utils/edit-control';
import InformationView from './assignment-utils/Information-view';
import HotelsInGroupView from './hotel-in-group/hotel-in-group';
import HotelsOutGroupView from './hotel-out-group/hotel-out-group';
import HotelViewBase from './assignment-utils/hotel-view-base';

export {
  CustomFilterView,
  EditControl,
  InformationView,
  HotelsInGroupView,
  HotelsOutGroupView,
  HotelGroups,
  HotelGroupsUINext,
  HotelAssociations,
  HotelViewBase,
};
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
/**
 * Class representing a navigation tabs for HotelCenter Assignment
 * @extends View
 */
export class HotelCenterAssignment extends DeterministicView {
  /**
  * Initializes HotelCenterAssignment
  * @returns {undefined}
  */
  initialize({
    isUINext = false,
    router,
    perfMarker,
    preferenceStoreFactory,
    preferenceService,
    sessionStore,
  } = {}) {
    this.i18n = i18n;
    this.isUINext = isUINext;

    this.hotelGroups = new HotelGroupsUINext({ router, perfMarker });
    const hotelAssociations = new HotelAssociations({
      perfMarker,
      isUINext,
      preferenceStoreFactory,
      preferenceService,
      sessionStore,
    });

    this.listenTo(this.hotelGroups, 'selectionChanged', ({
      selectedGroup,
      ungroupedGroupId,
      selectedSubAccount,
      isSubAccountSelected,
    }) => {
      this.getChild('hotel-associations').setState({
        selectedGroup,
        ungroupedGroupId,
        selectedSubAccount,
        isSubAccountSelected,
      });
      this.isSubAccountSelected = isSubAccountSelected;
    });

    this.listenTo(this.hotelGroups, 'noSubAccount', () => this.getChild('hotel-associations').setState({ noSubAccount: true }));

    this.listenTo(hotelAssociations, 'selectionModified', () => this.onGroupModified(this.isSubAccountSelected));
    this.listenTo(hotelAssociations, 'selectionDeleted', () => this.onGroupModified(this.isSubAccountSelected));
    this.listenTo(hotelAssociations, 'associationChanged', this.onGroupModified);

    this.setChild('hotel-groups', this.hotelGroups);
    this.setChild('hotel-associations', hotelAssociations);
  }

  get template() {
    return template;
  }

  onGroupModified(updateTitleBar) {
    this.hotelGroups.refreshHotelGroups({ resetSelection: false, loadState: false });
    this.hotelGroups.fetchAssociations().then((response) => {
      this.hotelGroups.disableDownload(response.totalCount === 0);
    });
    if (updateTitleBar) {
      this.trigger('modify:subAccount');
    }
  }
}
